import { render, staticRenderFns } from "./ParsersTable.vue?vue&type=template&id=130bd5bc&scoped=true"
import script from "./ParsersTable.vue?vue&type=script&lang=js"
export * from "./ParsersTable.vue?vue&type=script&lang=js"
import style0 from "./ParsersTable.vue?vue&type=style&index=0&id=130bd5bc&prod&lang=scss&scoped=true"
import style1 from "./ParsersTable.vue?vue&type=style&index=1&id=130bd5bc&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "130bd5bc",
  null
  
)

export default component.exports